class StarterSetForm extends HTMLElement {
  constructor() {
    super();

    // 2026-09-23, Multi-Instanz-Faehigkeit (Single+Duo-Buybox gleichzeitig auf einer Seite,
    // siehe home-hero-product-flexplan.liquid): scopeRoot ist der naechste Vorfahre mit einer
    // '#StarterKitBg-...'-ID (existiert auf der ECHTEN PDP NIE -> faellt dort automatisch auf
    // 'document' zurueck, exakt das alte, unveraenderte Verhalten). colorScopeRoot ist analog
    // ueber ein optionales '[data-buybox-instance]'-Wrapper-Element - nur unsere neue Duo-Instanz
    // auf der Homepage traegt das (mit eigenen, kompakten Farb-Swatches); die bestehende
    // Single-Instanz UND die echte PDP nutzen weiterhin die globalen '.color-btn'-Swatches der
    // Galerie (document-Fallback, unveraendert). Noetig, weil ab jetzt potenziell 2 <purchase-
    // options>-Elemente auf derselben Seite existieren koennen (Single+Duo) und jede Instanz nur
    // IHRE EIGENEN Formular-/Preis-/Radio-Elemente lesen darf, nicht die der jeweils anderen.
    this.scopeRoot = this.closest('[id^="StarterKitBg-"]') || document;
    this.colorScopeRoot = this.closest('[data-buybox-instance]') || document;

    this.formEl = this.scopeRoot.querySelector('.product-form');
    this.bundleItemEls = this.formEl.querySelectorAll('.bundle-item');
    this.variantInput = this.formEl.querySelector('input[name="id"]');
    this.originalVariantId = this.variantInput?.value || '';
    this.originalProductId = this.variantInput?.getAttribute('data-productid') || '';
    this.data = this.getSubscriptionData();
    this.mergeAnnualData();
    this.lastDurationOption = 'subscription';
    this.init();
  }

  getSubscriptionData() {
    try {
      // Praefix-Match statt exaktem getElementById: buybuttons-2.liquid haengt jetzt IMMER
      // einen instance_key-Suffix an diese Script-ID (Default = section.id, siehe dortiger
      // Header-Kommentar) - Praefix-Suche findet sie unabhaengig vom genauen Suffix, scopeRoot
      // sorgt dafuer, dass bei 2 Instanzen jede ihre EIGENEN Daten liest.
      const el = this.scopeRoot.querySelector('script[id^="starter-set-subscription-data"]');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      console.warn('Invalid starter-set-subscription-data JSON');
      return {};
    }
  }

  // 2026-10-15 (Christian, A/B-Test 12-Monatsplan): optionale 3. Karte (Radio-Wert 'annual'),
  // gerendert von snippets/starter-kit-flexplan-part-annual-card.liquid. Deren Daten stehen in einem
  // eigenen JSON-Script (starter-set-annual-data-*), damit der grosse Datenblob in buybuttons-2
  // unveraendert bleibt. Hardware = 90T-Abo-Hardware (gleicher Geraetepreis). Ohne Karte bleibt
  // this.data.annual_variant undefined -> alle Pfade unten verhalten sich exakt wie vorher.
  mergeAnnualData() {
    try {
      const el = this.scopeRoot.querySelector('script[id^="starter-set-annual-data"]');
      if (!el) return;
      const annual = JSON.parse(el.textContent);
      if (annual && annual.annual_variant) {
        this.data.annual_variant = annual.annual_variant;
        this.data.annual_bundle_hardware = this.data.additional_bundle_hardware || null;
      }
    } catch (e) {
      console.warn('Invalid starter-set-annual-data JSON');
    }
  }

  // 2026-10-19 (Christian): Einzelkauf ("Lieber einmalig kaufen") folgt auch der 12M-Karte:
  // 12M-Pads ohne Selling Plan + 90T-Einzelkauf-Geraet (gleiche Farbe).
  isOnetimeFollowsAnnual() {
    const v = this.scopeRoot.querySelector('[data-purchase-option]:checked')?.value;
    return v !== 'subscription' && v !== 'onetime-additional' && v !== 'annual'
      && this.lastDurationOption === 'annual' && !!this.data.annual_variant && !!this.data.additional_bundle_hardware_onetime;
  }

  getIsAnnualOption() {
    return this.scopeRoot.querySelector('[data-purchase-option]:checked')?.value === 'annual';
  }

  getMatchedAnnualHardwareVariant() {
    const hw = this.data.annual_bundle_hardware;
    if (!hw) return null;
    const selectedColor = this.colorScopeRoot.querySelector('.color-btn.checked')?.dataset.color;
    if (!selectedColor) return null;
    const selectedColorLower = selectedColor.toLowerCase();
    return (hw.variants || []).find((v) => v.option1?.toLowerCase() === selectedColorLower) || null;
  }

  getIsSubscription() {
    return this.scopeRoot.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
  }
  getIsAdditionalOption() {
    return this.scopeRoot.querySelector('[data-purchase-option]:checked')?.value === 'onetime-additional';
  }

  getCurrentPurchaseOptionValue() {
    return this.scopeRoot.querySelector('[data-purchase-option]:checked')?.value || null;
  }

  updateMainVariantId() {
    if (!this.variantInput) return;

    // 12M-Karte: immer das (einzige) Pad-Variant des 365-Tage-Produkts.
    if ((this.getIsAnnualOption() || this.isOnetimeFollowsAnnual()) && this.data.annual_variant) {
      this.variantInput.value = this.data.annual_variant.variant_id;
      this.variantInput.setAttribute('data-productid', this.data.annual_variant.product_id);
      this.updateSelectedVariantAvailability();
      return;
    }

    const isSubscription = this.getIsSubscription();
    const isAdditionalOption = this.getIsAdditionalOption();
    const selectedColorBtn = this.colorScopeRoot.querySelector('.color-btn.checked');
    const selectedColor = selectedColorBtn?.dataset.color;

    const onetimeFollowsAdditional = !isSubscription && !isAdditionalOption && this.lastDurationOption === 'onetime-additional' && !!this.data.additional_bundle_hardware_onetime;

    const original_product_variants = (isAdditionalOption || onetimeFollowsAdditional) ? this.data.additional_variant?.variants || [] : this.data.original_product_variants || [];

    const isFlexplanOnetime = !isSubscription && !isAdditionalOption && !onetimeFollowsAdditional && !!this.data.subscription_bundle_hardware_onetime;

    const variants = (isSubscription || isFlexplanOnetime)
      ? this.data.duplicate_product?.variants || []
      : (onetimeFollowsAdditional ? this.data.additional_variant?.variants || [] : original_product_variants);

    const originalVariantId = isAdditionalOption ? this.data.additional_variant?.variant_id : this.originalVariantId;
    const originalProductId = isAdditionalOption ? this.data.additional_variant?.product_id : this.originalProductId;

    let matchedVariant = null;
    if (selectedColor) {
      const selectedColorLower = selectedColor.toLowerCase();
      matchedVariant = variants.find((v) => v.option1?.toLowerCase() === selectedColorLower);
    }

    if (matchedVariant) {
      this.variantInput.value = matchedVariant.id;
      this.variantInput.setAttribute('data-productid', matchedVariant.product_id);
    } else {
      const defaultVariantId = (isSubscription || isFlexplanOnetime)
        ? this.data.duplicate_product?.variant_id
        : (onetimeFollowsAdditional ? this.data.additional_variant?.variant_id : originalVariantId);
      const defaultProductId = (isSubscription || isFlexplanOnetime)
        ? this.data.duplicate_product?.product_id
        : (onetimeFollowsAdditional ? this.data.additional_variant?.product_id : originalProductId);

      this.variantInput.value = defaultVariantId;
      this.variantInput.setAttribute('data-productid', defaultProductId);
    }

    this.updateSelectedVariantAvailability();
  }

  priceToCents(price) {
    if (typeof price === 'string') {
      const n = parseInt(price.replace('.', ''), 10);
      return isNaN(n) ? 0 : n;
    }
    return Number(price) || 0;
  }

  // 2026-09-21, Bugfix (Christian: "faellt bei Reload auf 89,99 zurueck"): vorher wurde pro
  // Aufruf von updateSelectedVariantAvailability() NUR die Preis-Anzeige der GERADE aktiven
  // Karte (isSubscription/isAdditionalOption) aktualisiert - die jeweils ANDERE, nicht aktive
  // Karte behielt den rohen, unvollstaendigen Server-Render (Liquid zeigt initial nur den
  // nackten Pad-Preis ohne Hardware und ohne echten Selling-Plan-Preis, siehe
  // buybuttons-1/2.liquid data-subscription-price / data-onetime-additional-price). Solange der
  // Nutzer JEDE Karte einmal per echtem Klick auswaehlte (das feuert ein 'change'-Event), wurde
  // sie dabei live korrigiert - aber bei einem Seiten-Reload kann der Browser den zuletzt
  // gewaehlten Radio-Status wiederherstellen OHNE ein 'change'-Event zu feuern, wodurch die
  // Preis-Korrektur fuer DIESEN init()-Aufruf ausblieb und der rohe SSR-Wert (z.B. 89,99 statt
  // 149,99 fuer die 90T-Karte) sichtbar blieb. Fix: beide Karten-Kopfpreise werden jetzt bei
  // JEDEM Aufruf dieser Funktion (Seitenladen, Farbwechsel, Plan-Wechsel) unconditional aus den
  // echten Shopify-Daten neu berechnet - komplett unabhaengig davon, welche Karte gerade als
  // "aktiv" gilt. Macht die Anzeige selbstkorrigierend/idempotent statt von Timing/Reload-
  // Verhalten des Browsers abhaengig.
  // 2026-09-21, Buying-Box-Redesign "Meisterloesung" (Christian): der Kopf-Preis der beiden
  // Karten zeigt jetzt den MONATSPREIS (nur Pad-Bundle-Anteil / Laufzeit-Tage * 30, OHNE
  // Hardware) statt des vollen Kombi-Preises (Pad+Hardware) mit Streichpreis wie zuvor -
  // identische Formel wie server-seitig sub_per_month_cents/add_per_month_cents in
  // buybuttons-1/2.liquid. Der volle Kombi-Preis mit Streichpreis steht weiterhin in der "Heute
  // im Warenkorb"-Box, dort bewusst NUR server-gerendert (keine JS-Aktualisierung), weil
  // Hardware-Preise nachweislich farbunabhaengig sind (siehe claude/pdp-pricing-card-30-90-tage-
  // meisterloesung-sept2026.md) - reduziert die Angriffsflaeche fuer genau die Art von Bug, die
  // den Reload-Fix oben noetig gemacht hat. Reine Praesentations-Aenderung, KEINE neue
  // Preislogik: dieselbe padVariant/hasRealSellingPlan-Quelle wie zuvor.
  refreshCardHeadlinePrice({ priceEl, padVariant, hasRealSellingPlan, durationDays }) {
    if (!priceEl || !padVariant) return;

    const realSellingPlanPrice = hasRealSellingPlan ? padVariant.selling_plan_price : null;
    const mainPriceCents = realSellingPlanPrice != null ? this.priceToCents(realSellingPlanPrice) : this.priceToCents(padVariant.price);

    // Liquid `divided_by` rundet bei Integer-Operanden immer AB (Ruby-Integer-Division) - hier
    // bewusst Math.floor statt Math.round, damit der initiale SSR-Wert (sub_per_month_cents /
    // add_per_month_cents) und diese JS-Neuberechnung nach Farb-/Plan-Wechsel exakt
    // uebereinstimmen und die Zahl nicht bei jedem Wechsel um 1 Cent springt.
    const safeDuration = durationDays > 0 ? durationDays : 30;
    const monthlyCents = Math.floor((mainPriceCents * 30) / safeDuration);

    priceEl.innerHTML = `<span class="price"><span>${this.formatMoney(monthlyCents)}</span></span>`;
  }

  // 2026-09-24, A/B-Test "Gesamtpreis-Variante" (Christian): Gegenstueck zu
  // refreshCardHeadlinePrice() oben fuer price_display_mode == 'total' (siehe neues Block-Setting
  // in main-product-starter-kit-flexplan.liquid/home-hero-product-flexplan.liquid). Zeigt statt des
  // Monatspreises den vollen Liefer-/Gesamtpreis (Pad-Bundle + farbabhaengige Hardware-Variante).
  // Nutzt die bestehenden getMatchedHardwareVariant()-Helfer fuer die farbabhaengige Hardware-
  // Zuordnung, statt diese Logik hier zu duplizieren.
  //
  // 2026-09-24 (Christian-Feedback, Screenshot): der Streichpreis muss exakt dem "Einzelkauf"-Preis
  // entsprechen (siehe updateOnetimeLinkPrices() unten) -- NICHT padVariant.compare_at_price (ein
  // anderer, teils abweichender Marketing-Anker). Der echte Einzelkauf-Preis ist padVariant.price
  // (Pad-Bundle OHNE Selling-Plan-Rabatt) + der echte Einzelkauf-Hardware-Preis (matchedHwOnetime
  // Variant, sonst Fallback auf matchedHwVariant.compare_at_price/price) -- exakt dieselbe Formel wie
  // dort.
  refreshCardTotalPrice({ priceEl, compareEl, sublineEl, padVariant, hasRealSellingPlan, durationDays, matchedHwVariant, matchedHwOnetimeVariant }) {
    if (!priceEl || !padVariant) return;

    const realSellingPlanPrice = hasRealSellingPlan ? padVariant.selling_plan_price : null;
    const mainPriceCents = realSellingPlanPrice != null ? this.priceToCents(realSellingPlanPrice) : this.priceToCents(padVariant.price);
    const hwPriceCents = matchedHwVariant ? this.priceToCents(matchedHwVariant.price) : 0;
    const totalPriceCents = mainPriceCents + hwPriceCents;

    const mainCompareCents = this.priceToCents(padVariant.price);
    const hwCompareCents = matchedHwOnetimeVariant
      ? this.priceToCents(matchedHwOnetimeVariant.price)
      : (matchedHwVariant ? (this.priceToCents(matchedHwVariant.compare_at_price) || hwPriceCents) : 0);
    const totalCompareCents = mainCompareCents + hwCompareCents;

    priceEl.innerHTML = `<span class="price"><span>${this.formatMoney(totalPriceCents)}</span></span>`;

    if (compareEl) {
      if (totalCompareCents > totalPriceCents) {
        compareEl.textContent = this.formatMoney(totalCompareCents);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (sublineEl) {
      const safeDuration = durationDays > 0 ? durationDays : 30;
      // Liquid `divided_by` rundet bei Integer-Operanden immer AB -- Math.floor statt Math.round,
      // damit dieser Wert mit sub_per_month_cents/add_per_month_cents (Erst-Render) uebereinstimmt.
      const monthlyCents = Math.floor((mainPriceCents * 30) / safeDuration);
      // 2026-09-24 (Christian-Feedback Runde 3): Hinweis nur zeigen, wenn er sich vom gerade genannten
      // Laufzeit-Preis unterscheidet -- bei 30 Tagen ist monthlyCents == mainPriceCents (identisch zum
      // Liquid-Verhalten in starter-kit-flexplan-part-buybuttons-1/2.liquid).
      const monthlyHint = safeDuration !== 30
        ? ` <span class="pcard-price-permonth-hint">(nur ${this.formatMoney(monthlyCents)} pro Monat)</span>`
        : '';
      sublineEl.innerHTML = `Ger&auml;t einmalig ${this.formatMoney(hwPriceCents)} &middot; danach ${safeDuration === 30 ? 'jeden Monat' : (safeDuration % 30 === 0 ? `alle ${safeDuration / 30} Monate` : `alle ${safeDuration} Tage`)} ${this.formatMoney(mainPriceCents)}${monthlyHint}`;
    }
  }

  updateSelectedVariantAvailability() {
    const activeColorBtn = this.colorScopeRoot.querySelector('.color-btn.checked');
    if (!activeColorBtn) return;

    const selectedColor = activeColorBtn.dataset.color;

    if (this.data.price_display_mode === 'total') {
      this.refreshCardTotalPrice({
        priceEl: this.scopeRoot.querySelector('[data-subscription-price]'),
        compareEl: this.scopeRoot.querySelector('[data-subscription-price-compare]'),
        sublineEl: this.scopeRoot.querySelector('[data-subscription-price-subline]'),
        padVariant: this.data.duplicate_product?.variants?.[0],
        hasRealSellingPlan: !!this.data.duplicate_product?.selling_plan_id,
        durationDays: this.data.duplicate_product?.duration_days,
        matchedHwVariant: this.getMatchedHardwareVariant(),
        matchedHwOnetimeVariant: this.getMatchedOnetimeHardwareVariant(),
      });
      this.refreshCardTotalPrice({
        priceEl: this.scopeRoot.querySelector('[data-onetime-additional-price]'),
        compareEl: this.scopeRoot.querySelector('[data-onetime-additional-price-compare]'),
        sublineEl: this.scopeRoot.querySelector('[data-onetime-additional-price-subline]'),
        padVariant: this.data.additional_variant?.variants?.[0],
        hasRealSellingPlan: !!this.data.additional_variant?.selling_plan_id,
        durationDays: this.data.additional_variant?.duration_days,
        matchedHwVariant: this.getMatchedAdditionalHardwareVariant(),
        matchedHwOnetimeVariant: this.getMatchedAdditionalOnetimeHardwareVariant(),
      });
    } else {
      this.refreshCardHeadlinePrice({
        priceEl: this.scopeRoot.querySelector('[data-subscription-price]'),
        padVariant: this.data.duplicate_product?.variants?.[0],
        hasRealSellingPlan: !!this.data.duplicate_product?.selling_plan_id,
        durationDays: this.data.duplicate_product?.duration_days,
      });
      this.refreshCardHeadlinePrice({
        priceEl: this.scopeRoot.querySelector('[data-onetime-additional-price]'),
        padVariant: this.data.additional_variant?.variants?.[0],
        hasRealSellingPlan: !!this.data.additional_variant?.selling_plan_id,
        durationDays: this.data.additional_variant?.duration_days,
      });
      if (this.data.annual_variant) {
        this.refreshCardHeadlinePrice({
          priceEl: this.scopeRoot.querySelector('[data-annual-price]'),
          padVariant: this.data.annual_variant.variants?.[0],
          hasRealSellingPlan: !!this.data.annual_variant.selling_plan_id,
          durationDays: this.data.annual_variant.duration_days,
        });
      }
    }

    const isSubscription = this.getIsSubscription();
    const isAdditionalOption = this.getIsAdditionalOption();
    const isAnnual = this.getIsAnnualOption() && !!this.data.annual_variant;
    const onetimeFollowsAnnual = this.isOnetimeFollowsAnnual();
    const onetimeFollowsAdditional = !isSubscription && !isAdditionalOption && !isAnnual && this.lastDurationOption === 'onetime-additional' && !!this.data.additional_bundle_hardware_onetime;
    const isFlexplanOnetime = !isSubscription && !isAdditionalOption && !isAnnual && !onetimeFollowsAnnual && !onetimeFollowsAdditional && !!this.data.subscription_bundle_hardware_onetime;
    const original_product_variants = (isAdditionalOption || onetimeFollowsAdditional) ? this.data.additional_variant?.variants || [] : this.data.original_product_variants || [];
    const variants = (isAnnual || onetimeFollowsAnnual)
      ? this.data.annual_variant.variants || []
      : (isSubscription || isFlexplanOnetime) ? this.data.duplicate_product?.variants || [] : original_product_variants;

    const hardwareProduct = isAnnual
      ? this.data.annual_bundle_hardware
      : onetimeFollowsAnnual
      ? this.data.additional_bundle_hardware_onetime
      : isSubscription
      ? this.data.subscription_bundle_hardware
      : isAdditionalOption
        ? this.data.additional_bundle_hardware
        : onetimeFollowsAdditional
          ? this.data.additional_bundle_hardware_onetime
          : isFlexplanOnetime
            ? this.data.subscription_bundle_hardware_onetime
            : null;

    // 2026-09-23, Bugfix (Christian: "90T-Karte zeigt im CTA-Button einen falschen % Wert,
    // der nicht zum -X%-Badge auf der Karte passt"): der Vergleichspreis fuer die Hardware
    // (siehe hardwareCompareCents weiter unten) darf fuer die subscription-/additional-Karten
    // NICHT aus matchedHardwareVariant.compare_at_price kommen - das ist der pauschale
    // Marketing-Anker der ABO-Hardware-Variante (fuer ALLE Laufzeiten gleich, z.B. 150€ Duo),
    // waehrend der Karten-Badge (buybuttons-1/2.liquid, sub_price_diff_pct/add_price_diff_pct)
    // bereits seit dem 2026-09-22-Fix korrekt den ECHTEN, laufzeit-spezifischen Einzelkauf-Preis
    // aus subscription_hardware_product_onetime/additional_hardware_product_onetime verwendet
    // (z.B. 110€ statt 150€ fuer eine 90-Tage-Karte). Ohne diesen Fix lief der JS-berechnete
    // CTA-Button-Prozentsatz auf einen zu hohen Wert (39% statt korrekter 31%), weil er gegen den
    // hoeheren pauschalen Anker statt gegen den echten Laufzeit-Preis rechnete. Fix: dieselbe
    // laufzeit-spezifische "_onetime"-Hardware-Quelle wie im Liquid-Badge auch hier fuer den
    // Vergleichspreis heranziehen.
    // 12M: Vergleichspreis mit dem 90T-Einzelkauf-Geraet, wie Side Cart und Summary (16.10.).
    const hardwareOnetimeProduct = isAnnual
      ? this.data.additional_bundle_hardware_onetime
      : isSubscription
      ? this.data.subscription_bundle_hardware_onetime
      : isAdditionalOption
        ? this.data.additional_bundle_hardware_onetime
        : null;

    let matchedVariant;
    let matchedHardwareVariant = null;
    let matchedHardwareOnetimeVariant = null;

    if (hardwareProduct) {
      matchedVariant = variants[0] || null;
      const selectedColorLower = selectedColor?.toLowerCase();
      matchedHardwareVariant = (hardwareProduct.variants || []).find((v) => v.option1?.toLowerCase() === selectedColorLower) || null;
      if (hardwareOnetimeProduct) {
        matchedHardwareOnetimeVariant = (hardwareOnetimeProduct.variants || []).find((v) => v.option1?.toLowerCase() === selectedColorLower) || null;
      }
    } else {
      matchedVariant = variants.find((v) => v.option1?.toLowerCase() === selectedColor?.toLowerCase());
    }

    // 2026-09-21, Buying-Box-Redesign "Meisterloesung" (Christian): [data-subscription-price] /
    // [data-onetime-additional-price] sind jetzt reine Monatspreis-Kopfzeilen, ausschliesslich
    // von refreshCardHeadlinePrice() oben in dieser Funktion befuellt. Der Block weiter unten
    // (kombinierter Pad+Hardware-Preis MIT Streichpreis) schreibt deshalb nur noch in den
    // unveraenderten [data-onetime-price]-Einzelkauf-Link (3. Option, kein Redesign) - fuer
    // isSubscription/isAdditionalOption bleibt priceEl bewusst null, damit der Monatspreis nicht
    // sofort wieder ueberschrieben wird.
    const priceEl = (isSubscription || isAdditionalOption || isAnnual) ? null : this.scopeRoot.querySelector('[data-onetime-price]');

    const hasRealSellingPlan = (isSubscription && !!this.data.duplicate_product?.selling_plan_id) || (isAdditionalOption && !!this.data.additional_variant?.selling_plan_id) || (isAnnual && !!this.data.annual_variant?.selling_plan_id);

    let combinedPriceCents = 0;
    let combinedCompareCents = 0;

    if (matchedVariant) {
      // 2026-09-21, Bugfix (Christian: echte Recharge-Preise in Buying-Box statt Schaetz-Faktor):
      // vorher wurde der Abo-Preis ueber einen hart codierten Naeherungsfaktor (0.67 ~= -33%) aus
      // dem vollen Variant-Preis GESCHAETZT - nur ein Platzhalter, solange noch kein echter Selling
      // Plan existierte. Sobald Christian in Recharge einen echten Preis fuer diesen Selling Plan
      // setzt, weicht der Schaetzfaktor davon ab (siehe Bug: 90T zeigte 156,29 statt echter 149,99,
      // weil 0.67 zufaellig nur beim 30T-Zieltarif fast passte). Jetzt wird, wenn vorhanden, der
      // ECHTE, von Shopify/Recharge berechnete Selling-Plan-Preis (matchedVariant.selling_plan_price,
      // aus variant.selling_plan_allocations.first.price im Liquid-Datenblob) direkt verwendet -
      // reagiert automatisch auf jede kuenftige Preisaenderung in Recharge, ohne dass hier je wieder
      // ein Schaetzwert nachgezogen werden muss. Ohne echten Selling Plan (z.B. noch nicht in
      // Recharge angelegt) bleibt der volle, unrabattierte Preis stehen (kein geratener Rabatt).
      const realSellingPlanPrice = hardwareProduct && hasRealSellingPlan ? matchedVariant.selling_plan_price : null;
      const mainPriceCents = realSellingPlanPrice != null ? this.priceToCents(realSellingPlanPrice) : this.priceToCents(matchedVariant.price);
      const hardwarePriceCents = matchedHardwareVariant ? this.priceToCents(matchedHardwareVariant.price) : 0;
      combinedPriceCents = mainPriceCents + hardwarePriceCents;

      // Der Vergleichspreis ("war"-Preis) ist immer der volle Einzelkauf-Referenzpreis, nie der
      // rabattierte Abo-Preis (Preis-Fix vom 2026-09-21).
      const mainCompareCents = this.priceToCents(matchedVariant.compare_at_price) || this.priceToCents(matchedVariant.price) || mainPriceCents;
      const hardwareCompareCents = matchedHardwareVariant
        ? (matchedHardwareOnetimeVariant
            ? this.priceToCents(matchedHardwareOnetimeVariant.price)
            : (isAnnual ? hardwarePriceCents : (this.priceToCents(matchedHardwareVariant.compare_at_price) || hardwarePriceCents)))
        : 0;
      combinedCompareCents = mainCompareCents + hardwareCompareCents;

      if (priceEl) {
        const priceHTML =
          combinedCompareCents > combinedPriceCents
            ? `<span class="price price--sale"><span>${this.formatMoney(combinedPriceCents)}</span><span><s>${this.formatMoney(combinedCompareCents)}</s> </span> </span>`
            : `<span class="price">${this.formatMoney(combinedPriceCents)}</span>`;

        priceEl.innerHTML = priceHTML;
      }
    }

    const submitBtn = this.formEl.querySelector('[data-bundle-submit]');
    const isMainVariantAvailable = !!(matchedVariant && matchedVariant.available && (!hardwareProduct || (matchedHardwareVariant && matchedHardwareVariant.available)));
    // 12M ohne Recharge-Selling-Plan: nie zum Ankerpreis als Einzelkauf in den Cart legen.
    if (isAnnual && !this.data.annual_variant?.selling_plan_id) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.textContent = '12-Monatsplan nicht verfügbar';
    } else if (!isMainVariantAvailable) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.textContent = window.variantStrings?.soldOut || 'Sold out';
    } else {
      submitBtn.removeAttribute('disabled');
      // 2026-09-22 (Christian): CTA-Text von "In den Warenkorb – Preis" auf
      // "Jetzt Set sichern - X% sparen" umgestellt (X = Ersparnis ggue. Vergleichspreis,
      // folgt live der aktuell gewaehlten Plan-/Laufzeit-Karte) - IM8/Hydraid-Stil.
      // 2026-10-25 (Christian): Euro-Betrag statt Prozent ("Jetzt Set sichern – €60 sparen"), gleiche Zahl wie
      // "Du sparst" in der Zusammenfassung und "Spare €60" auf Collection-Karten. Ganze Euro ohne ",00".
      // 28.10.2026 (Christian): auf volle Betraege abgerundet (z. B. 100,01 -> 100), wie "Du sparst".
      const savedCents = combinedCompareCents > combinedPriceCents ? Math.floor((combinedCompareCents - combinedPriceCents) / 100) * 100 : 0;
      const savedStr = savedCents > 0 ? this.formatMoney(savedCents).replace(/[.,]00(?=[^0-9]*$)/, '') : '';
      const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
      const baseText = savedCents > 0
        ? (isEnglish ? `Secure your set now – save ${savedStr}` : `Jetzt Set sichern – ${savedStr} sparen`)
        : (isEnglish ? 'Secure your set now' : 'Jetzt Set sichern');
      submitBtn.innerHTML = baseText;

      this.variantInput.value = matchedVariant.id;
      this.variantInput.setAttribute('data-productid', matchedVariant.product_id);
    }

    this.updateOnetimeLinkPrices();
  }

  // 2026-09-21 (Christian: "Einzelkauf-Preis automatisch berechnet statt manuell im Customizer") -
  // berechnet den EINEN, geteilten "Einzelkauf"-Link-Preis ([data-onetime-price], liegt UNTER den
  // beiden Laufzeit-Karten) live aus den echten Pad-Bundle- + Hardware-Einzelkauf-Varianten (nach
  // aktuell gewaehlter Farbe UND nach zuletzt aktiv gewaehlter Laufzeit-Karte) statt aus dem
  // statischen Customizer-Fixwert (purchase_onetime_price_for_subscription/_additional). Laeuft bei
  // jedem Aufruf von updateSelectedVariantAvailability() (Seitenladen, Farbwechsel, Plan-Wechsel),
  // damit eine Preisaenderung an den echten Shopify-Varianten (z.B. eine zeitlich begrenzte Aktion)
  // sich sofort ueberall niederschlaegt, ohne dass Christian noch manuell im Theme-Editor nachziehen
  // muss.
  //
  // WICHTIG (Bugfix, Christian-Screenshot 90T-Karte): [data-onetime-additional-price] ist KEIN
  // zweiter Einzelkauf-Link, sondern das eigene Headline-Preis-Element der 90-Tage-Vorrat-ABO-Karte
  // selbst (siehe buybuttons-2.liquid) - wird bereits weiter oben in
  // updateSelectedVariantAvailability() ueber "priceEl" korrekt mit dem Abo-Preis befuellt. Die
  // erste Version dieser Funktion hat es hier faelschlich ein 2. Mal mit dem Einzelkauf-Preis
  // ueberschrieben (dadurch verschwand der Abo-Rabatt/Streichpreis der 90T-Karte komplett). Diese
  // Funktion fasst NUR NOCH [data-onetime-price] an.
  //
  // Der Link muss ausserdem der zuletzt aktiv gewaehlten Laufzeit-Karte folgen (this.
  // lastDurationOption: 'subscription'=30T / 'onetime-additional'=90T) - sonst bleibt er beim
  // Kartenwechsel auf der 30T-Zahl haengen (2. gemeldeter Bug). lastDurationOption wird deshalb HIER
  // zentral aktualisiert (vorher in einer separaten updateDynamicOnetimePrice()-Methode, die mit
  // dieser Live-Berechnung ueberfluessig wurde und entfernt ist) - davon haengt auch die
  // Einzelkauf-Radio-Persistenz ab (siehe -buybuttons-3.liquid).
  //
  // Nur aktiv, wenn die Hardware-Split-Architektur fuer die jeweilige Laufzeit ueberhaupt existiert
  // (subscription_bundle_hardware_onetime / additional_bundle_hardware_onetime gesetzt) - bei
  // aelteren Starter-Kit-Produkten ohne Hardware-Split (Feld leer) bleibt das alte statische/
  // Customizer-Verhalten bestehen (Rueckwaerts-Kompatibilitaet, Fallback unten).
  updateOnetimeLinkPrices() {
    const currentOption = this.getCurrentPurchaseOptionValue();
    if (currentOption === 'subscription') {
      this.lastDurationOption = 'subscription';
    } else if (currentOption === 'onetime-additional') {
      this.lastDurationOption = 'onetime-additional';
    } else if (currentOption === 'annual' && this.data.annual_variant) {
      this.lastDurationOption = 'annual';
    }

    const activeColorBtn = this.colorScopeRoot.querySelector('.color-btn.checked');
    const selectedColorLower = activeColorBtn?.dataset.color?.toLowerCase();
    const useAdditionalContext = this.lastDurationOption === 'onetime-additional';
    const useAnnualContext = this.lastDurationOption === 'annual' && !!this.data.annual_variant;

    const padVariants = useAnnualContext
      ? this.data.annual_variant.variants
      : (useAdditionalContext ? this.data.additional_variant?.variants : this.data.duplicate_product?.variants);
    const hwProduct = (useAdditionalContext || useAnnualContext) ? this.data.additional_bundle_hardware_onetime : this.data.subscription_bundle_hardware_onetime;

    const onetimeEl = this.scopeRoot.querySelector('[data-onetime-price]');
    let handled = false;

    if (onetimeEl && Array.isArray(padVariants) && padVariants.length && hwProduct) {
      const padVariant = padVariants[0];
      const hwVariant =
        (hwProduct.variants || []).find((v) => v.option1?.toLowerCase() === selectedColorLower) ||
        hwProduct.variants?.[0];

      if (padVariant && hwVariant) {
        const priceCents = this.priceToCents(padVariant.price) + this.priceToCents(hwVariant.price);
        const compareCents =
          (this.priceToCents(padVariant.compare_at_price) || this.priceToCents(padVariant.price)) +
          (this.priceToCents(hwVariant.compare_at_price) || this.priceToCents(hwVariant.price));

        onetimeEl.innerHTML =
          compareCents > priceCents
            ? `<span class="price price--sale"><span>${this.formatMoney(priceCents)}</span><span><s>${this.formatMoney(compareCents)}</s> </span> </span>`
            : `<span class="price">${this.formatMoney(priceCents)}</span>`;
        handled = true;
      }
    }

    if (!handled && onetimeEl) {
      const dyn = this.data.onetime_dynamic_prices;
      if (dyn && (dyn.subscription != null || dyn.additional != null)) {
        const cents = useAdditionalContext ? dyn.additional : dyn.subscription;
        if (cents != null) {
          onetimeEl.innerHTML = `<span class="price">${this.formatMoney(cents)}</span>`;
        }
      }
    }
  }

  getMatchedHardwareVariant() {
    const hw = this.data.subscription_bundle_hardware;
    if (!hw) return null;

    const selectedColor = this.colorScopeRoot.querySelector('.color-btn.checked')?.dataset.color;
    if (!selectedColor) return null;

    const selectedColorLower = selectedColor.toLowerCase();
    return (hw.variants || []).find((v) => v.option1?.toLowerCase() === selectedColorLower) || null;
  }

  getMatchedOnetimeHardwareVariant() {
    const hw = this.data.subscription_bundle_hardware_onetime;
    if (!hw) return null;

    const selectedColor = this.colorScopeRoot.querySelector('.color-btn.checked')?.dataset.color;
    if (!selectedColor) return null;

    const selectedColorLower = selectedColor.toLowerCase();
    return (hw.variants || []).find((v) => v.option1?.toLowerCase() === selectedColorLower) || null;
  }

  getMatchedAdditionalHardwareVariant() {
    const hw = this.data.additional_bundle_hardware;
    if (!hw) return null;

    const selectedColor = this.colorScopeRoot.querySelector('.color-btn.checked')?.dataset.color;
    if (!selectedColor) return null;

    const selectedColorLower = selectedColor.toLowerCase();
    return (hw.variants || []).find((v) => v.option1?.toLowerCase() === selectedColorLower) || null;
  }

  getMatchedAdditionalOnetimeHardwareVariant() {
    const hw = this.data.additional_bundle_hardware_onetime;
    if (!hw) return null;

    const selectedColor = this.colorScopeRoot.querySelector('.color-btn.checked')?.dataset.color;
    if (!selectedColor) return null;

    const selectedColorLower = selectedColor.toLowerCase();
    return (hw.variants || []).find((v) => v.option1?.toLowerCase() === selectedColorLower) || null;
  }

  formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.moneyFormat || '{{ amount }}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? `${decimal}${parts[1]}` : '';
      return number == 0 ? '0' + dollarsAmount + centsAmount : dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)?.[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      // 2026-10-23: SE/CH-Formate wie in global.js (SEK '{{amount_with_space_separator}} kr' -> '1 695,00 kr')
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  generateBundleInstanceId() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  // 2026-09-21 (Cart-Description-Cleanup, Christian: "die Sorten noch darunter aufgelistet"):
  // liefert die im aktuell gewaehlten Pad-Bundle enthaltenen Sorten als fertig zusammengesetzten
  // String (z.B. "Bio-Brokkoli, Bio-Radieschen Mix"), passend zur gerade aktiven Laufzeit-Karte
  // (primaer/"subscription" vs. "additional"/2. Laufzeit). Wird HIER (nicht im Cart-Drawer)
  // ausgelesen, weil pad_flavor_titles[_additional] nur auf DIESER PDP-Seite im
  // starter-set-subscription-data-Blob existiert - der Cart-Drawer kann aber auf jeder beliebigen
  // Seite erscheinen und diese Daten nicht selbst nachladen. Ergebnis wird als Property
  // _pad_flavors an die Root-Cart-Zeile gehaengt (siehe addProductsToCart()); Underscore-Praefix
  // haelt die Property wie _bundle_instance aus dem nativen Checkout/Bestell-Mails heraus.
  //
  // 2026-09-21, Nachtrag (Christian: "mir gehts vor allem nicht um die refill namen sondern die
  // Sorten darin"): jeder Eintrag in pad_flavor_titles[_additional] ist jetzt {title, short_desc}
  // statt nur ein String (siehe buybuttons-3.liquid). short_desc kommt aus dem Shopify-Feld
  // mbc_fields.short_descripton ("Short Description" im Backend): bei "Mix"-Produkten (z.B.
  // "Bio-Antioxidant Mix") steht dort die Sorten-Aufschluesselung ("2x Bio-Saatpads Radieschen
  // Vulkan, 2x Bio-Saatpads Rucola & 2x Bio-Saatpads Brokkoli"), bei Einzelsorten-Produkten (z.B.
  // "Bio Mini-Brokkoli") ist es nur Marketing-Text ohne Aufzaehlung. Mengen werden bewusst NICHT
  // mit ausgegeben (Christians Wunsch: "nur die Sorten"). Ergebnis wird ueber alle Bundle-Produkte
  // hinweg dedupliziert (z.B. Brokkoli kommt sowohl als eigenes Produkt als auch als Teil von
  // Mix-Produkten vor).
  //
  // 2026-09-21, Bugfix (Christian-Screenshot: 30T-Sorten-Zeile zeigte den kompletten Marketing-Text
  // von "Bio Mini-Brokkoli" statt der Sorte): urspruengliche Heuristik "enthaelt short_desc ein
  // Komma -> Mix" war falsch-positiv, weil deutsche Dezimalkommas (z.B. "24,1 mg/100 g" im
  // Brokkoli-Marketingtext) ebenfalls ein Komma enthalten. Robuster: eine echte Sorten-Liste
  // beginnt IMMER mit einer Mengenangabe ("2x ...", "1x ..."), Marketing-Text tut das nie - daher
  // jetzt /^\d+x\s/i auf den GETRIMMTEN Textanfang statt eines simplen Komma-Checks.
  getPadFlavorsString(useAdditional) {
    const list = useAdditional ? this.data.pad_flavor_titles_additional : this.data.pad_flavor_titles;
    if (!Array.isArray(list)) return '';

    const flavors = [];
    const seen = {};
    const addFlavor = (name) => {
      const trimmed = (name || '').trim();
      if (trimmed && !seen[trimmed]) {
        seen[trimmed] = true;
        flavors.push(trimmed);
      }
    };

    list.forEach((item) => {
      if (!item || typeof item !== 'object') return;
      const shortDesc = typeof item.short_desc === 'string' ? item.short_desc.trim() : '';
      if (/^\d+x\s/i.test(shortDesc)) {
        shortDesc.split(/,|&/).forEach((piece) => {
          addFlavor(piece.trim().replace(/^\d+x\s*/i, ''));
        });
      } else if (typeof item.title === 'string' && item.title.length) {
        addFlavor(item.title);
      }
    });

    return flavors.join(', ');
  }

  addProductsToCart() {
    const isSubscription = this.getIsSubscription();
    const isAdditionalOption = this.getIsAdditionalOption();
    const isAnnual = this.getIsAnnualOption() && !!this.data.annual_variant;
    if (isAnnual && !this.data.annual_variant.selling_plan_id) return;
    const onetimeFollowsAnnual = this.isOnetimeFollowsAnnual();

    const onetimeFollowsAdditional = !isSubscription && !isAdditionalOption && !isAnnual && this.lastDurationOption === 'onetime-additional' && !!this.data.additional_bundle_hardware_onetime;
    const isFlexplanOnetime = !isSubscription && !isAdditionalOption && !isAnnual && !onetimeFollowsAnnual && !onetimeFollowsAdditional && !!this.data.subscription_bundle_hardware_onetime;

    const mainVariantId = (isAnnual || onetimeFollowsAnnual) ? this.data.annual_variant.variant_id : this.variantInput.value;
    const bundleInstanceId = this.generateBundleInstanceId();

    // 12M: gleiche Sorten wie der 90T-Vorrat (nur die vierfache Menge).
    const usesAdditionalFlavors = isAdditionalOption || onetimeFollowsAdditional || isAnnual || onetimeFollowsAnnual;
    const padFlavorsString = this.getPadFlavorsString(usesAdditionalFlavors);

    const mainItem = {
      id: mainVariantId,
      quantity: 1,
      properties: {
        bundle_root: 'StarterSet',
        _bundle_instance: bundleInstanceId,
        _bundle_additional_option: isAdditionalOption ? 'true' : '',
        _pad_flavors: padFlavorsString,
        // 2026-09-29 (Christian-Feedback): "Bearbeiten"-Stift im Cart-Drawer landete auf der PDP
        // des Pad-Bundle-Produkts (root.url in cart-drawer-v2.js) statt auf der echten Starter-Set-
        // Verkaufsseite, von der aus gekauft wurde -- das Pad-Bundle-Produkt selbst ist nur ein
        // internes Preis-/SKU-Vehikel (duplicate_product/additional_variant), keine echte PDP.
        // Aktuelle Seiten-URL beim Add-to-Cart als Property mitschicken, cart-drawer-v2.js nutzt sie
        // jetzt bevorzugt fuer den Bearbeiten-Link (siehe dortiger Kommentar).
        _pdp_url: window.location.pathname,
      },
    };

    if (isSubscription && this.data.duplicate_product?.selling_plan_id) {
      mainItem.selling_plan = this.data.duplicate_product.selling_plan_id;
    } else if (isAdditionalOption && this.data.additional_variant?.selling_plan_id) {
      mainItem.selling_plan = this.data.additional_variant.selling_plan_id;
    } else if (isAnnual) {
      mainItem.selling_plan = this.data.annual_variant.selling_plan_id;
    }

    // 2026-09-19, Cart-Fix (Christian: "Der ATC-Button muesste doch nur die Hardware und das
    // Bundle reinlegen"): Refill-Items (bundleItems/bundleItemsAdditional) werden NICHT MEHR als
    // eigene Cart-Positionen hinzugefuegt - die Zuordnung Pad-Bundle -> enthaltene Sorten ist reine
    // Fulfillment-Info (starter_set_products-Metafeld des Pad-Bundle-Produkts), kein separater
    // Checkout-Posten. Der Kunde bezahlt/erhaelt im Cart nur Pad-Bundle + Hardware (mainItem +
    // flexplanHardwareItem). Vorher haengten diese Items an einem Recharge-Selling-Plan-Namensmatch
    // (altes "Lieferung alle 2 Monate (Erste frei)"-Bundle-Builder-Modell), der nach der 1.
    // Lieferung erneut zum vollen Einzelpreis abgerechnet haette (Doppel-Berechnung oben auf den
    // bereits im Pad-Bundle-Preis enthaltenen Refill-Wert) und bei Produkten ohne diesen exakten
    // Plan (z.B. Energiegruen-Mix Probierpackung) komplett aus dem Cart fehlte.

    const giftItems = (isSubscription && window.FGS_SETTINGS && window.FGS_SETTINGS.enabled && Array.isArray(window.FGS_SETTINGS.gifts))
      ? window.FGS_SETTINGS.gifts.map((g) => ({ id: g.id, quantity: 1, properties: g.properties }))
      : [];

    const matchedHardwareVariant = isSubscription ? this.getMatchedHardwareVariant() : null;
    const matchedAdditionalHardwareVariant = isAdditionalOption ? this.getMatchedAdditionalHardwareVariant() : null;
    const matchedAdditionalOnetimeHardwareVariant = onetimeFollowsAdditional ? this.getMatchedAdditionalOnetimeHardwareVariant() : null;
    const matchedOnetimeHardwareVariant = isFlexplanOnetime ? this.getMatchedOnetimeHardwareVariant() : null;

    let flexplanHardwareItem = [];
    if (onetimeFollowsAnnual) {
      flexplanHardwareItem = [{
        id: this.getMatchedAdditionalOnetimeHardwareVariant()?.id || this.data.additional_bundle_hardware_onetime.variant_id,
        quantity: this.data.additional_bundle_hardware_onetime.quantity || 1,
        properties: {
          bundle_attached_to: 'StarterSet',
          _bundle_instance: bundleInstanceId,
        },
      }];
    } else if (isAnnual && this.data.annual_bundle_hardware) {
      flexplanHardwareItem = [{
        id: this.getMatchedAnnualHardwareVariant()?.id || this.data.annual_bundle_hardware.variant_id,
        quantity: this.data.annual_bundle_hardware.quantity || 1,
        properties: {
          bundle_attached_to: 'StarterSet',
          _bundle_instance: bundleInstanceId,
        },
      }];
    } else if (isSubscription && this.data.subscription_bundle_hardware) {
      flexplanHardwareItem = [{
        id: matchedHardwareVariant?.id || this.data.subscription_bundle_hardware.variant_id,
        quantity: this.data.subscription_bundle_hardware.quantity || 1,
        properties: {
          bundle_attached_to: 'StarterSet',
          _bundle_instance: bundleInstanceId,
        },
      }];
    } else if (isAdditionalOption && this.data.additional_bundle_hardware) {
      flexplanHardwareItem = [{
        id: matchedAdditionalHardwareVariant?.id || this.data.additional_bundle_hardware.variant_id,
        quantity: this.data.additional_bundle_hardware.quantity || 1,
        properties: {
          bundle_attached_to: 'StarterSet',
          _bundle_instance: bundleInstanceId,
        },
      }];
    } else if (onetimeFollowsAdditional && this.data.additional_bundle_hardware_onetime) {
      flexplanHardwareItem = [{
        id: matchedAdditionalOnetimeHardwareVariant?.id || this.data.additional_bundle_hardware_onetime.variant_id,
        quantity: this.data.additional_bundle_hardware_onetime.quantity || 1,
        properties: {
          bundle_attached_to: 'StarterSet',
          _bundle_instance: bundleInstanceId,
        },
      }];
    } else if (isFlexplanOnetime && this.data.subscription_bundle_hardware_onetime) {
      flexplanHardwareItem = [{
        id: matchedOnetimeHardwareVariant?.id || this.data.subscription_bundle_hardware_onetime.variant_id,
        quantity: this.data.subscription_bundle_hardware_onetime.quantity || 1,
        properties: {
          bundle_attached_to: 'StarterSet',
          _bundle_instance: bundleInstanceId,
        },
      }];
    }

    const cartItems = [mainItem, ...flexplanHardwareItem, ...giftItems];

    const submitBtn = this.formEl.querySelector('[data-bundle-submit]');

    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems }),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject('Cart error')))
      .then(() => {
        window.SLIDECART_UPDATE?.();
        setTimeout(() => {
          // 2026-10-26: AMP deinstalliert, custom-cart-logic.js nicht mehr geladen (Logik lebt im Custom Side Cart)
          if (typeof window.handleCustomCartLogic === 'function') window.handleCustomCartLogic();
          window.SLIDECART_OPEN?.();
          document.body.classList.remove('scroll-lock-mobile');
        }, 300);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      });
  }

  setupPurchaseOptionListener() {
    const purchaseOptionsEl = document.querySelector('purchase-options');
    if (!purchaseOptionsEl) return;

    // 2026-09-23, Multi-Instanz-Fix: dieser Listener haengt auf 'document' (Delegation), damit
    // er JEDE [data-purchase-option]-Aenderung auf der Seite sieht. Bei nur EINER Instanz (echte
    // PDP, bisheriges Verhalten) ist das unproblematisch. Sobald 2 Instanzen (Single+Duo) auf
    // derselben Seite existieren, wuerde ohne Filter JEDE Instanz auf JEDE Radio-Aenderung
    // reagieren - auch auf die der jeweils ANDEREN Instanz. Fix: nur reagieren, wenn das
    // geaenderte Element zum selben '#StarterKitBg-...'-Scope gehoert wie diese Instanz
    // (this.scopeRoot). Auf der echten PDP sind beide Seiten immer 'document' (kein
    // StarterKitBg-Wrapper vorhanden) -> Bedingung immer erfuellt -> 0 Verhaltensaenderung.
    document.addEventListener('change', (e) => {
      if (!e.target || typeof e.target.matches !== 'function' || !e.target.matches('[data-purchase-option]')) return;
      const eventScope = (typeof e.target.closest === 'function' ? e.target.closest('[id^="StarterKitBg-"]') : null) || document;
      if (eventScope !== this.scopeRoot) return;
      this.updateMainVariantId();
      this.updateSelectedVariantAvailability();
    });
  }

  init() {
    const submitBtn = this.formEl.querySelector('[data-bundle-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addProductsToCart();
      });
    }

    this.setupPurchaseOptionListener();
    this.updateMainVariantId();
    this.updateSelectedVariantAvailability();
  }
}

if (!window.customElements.get('purchase-options')) {
  window.customElements.define('purchase-options', StarterSetForm);
}
